import React from "react";
import { useIntl } from "gatsby-plugin-intl";
import { polyfill } from "seamless-scroll-polyfill";
import NewsSlider from "@components/NewsSlider";
import DownloadButton from "@components/DownloadButton";
import Loading from "@components/Loading";
import mobileMainSectionBg01 from "@images/home/m-main-p-sec-bg-01.jpg";
import homeVideo from "@assets/videos/home-video.mp4";
import homeVideoWebm from "@assets/videos/home-video.webm";
import appBtnAndroid from "@assets/images/home/app-btn-android.png";
import appBtnIOS from "@assets/images/home/app-btn-ios.png";
import useWindowSize from "@hooks/useWindowSize";
import { MOBILE_BREAK_POINT } from "@models";
import { isMobile } from "react-device-detect";

if (typeof window !== "undefined") polyfill();

// prevent "MusicPlayer" in Root -> Navbar from refresh by useWindowSize
const HomePage = () => {
  const { locale } = useIntl();
  const { width } = useWindowSize();

  return (
    <>
      <Loading assets={[{ url: homeVideoWebm, type: "video" }]} />
      <div style={{ position: "relative", height: "100vh" }}>
        {width < MOBILE_BREAK_POINT ? (
          <img
            src={mobileMainSectionBg01}
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
            alt="kv"
          />
        ) : (
          <video autoPlay muted playsInline className="video">
            <source src={homeVideoWebm} type="video/webm" />
            <source src={homeVideo} type="video/mp4" />
          </video>
        )}
        {/* App store / Google Play Buttons */}
        <div
          style={{
            position: "absolute",
            width: "100%",
            bottom: "120px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}>
          {locale === "zh-Hans" ? (
            <DownloadButton />
          ) : (
            <div
              style={{
                maxWidth: "460px",
                width: "90vw",
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                columnGap: "2vw",
              }}>
              <a
                href={
                  isMobile
                    ? process.env.REACT_APP_APP_ADJUST_URL
                    : process.env.REACT_APP_APPLE_STORE_URL
                }
                target="_blank"
                rel="noopener noreferrer">
                <img src={appBtnIOS} alt="iOS-icon" style={{ width: "100%" }} />
              </a>
              <a
                href={
                  isMobile
                    ? process.env.REACT_APP_APP_ADJUST_URL
                    : process.env.REACT_APP_GOOGLE_PLAY_URL
                }
                target="_blank"
                rel="noopener noreferrer">
                <img src={appBtnAndroid} alt="google-play-icon" style={{ width: "100%" }} />
              </a>
            </div>
          )}
        </div>
        {/* App store / Google Play Buttons */}
      </div>
      <NewsSlider page="home" />
    </>
  );
};

export default HomePage;
